export default __webpack_public_path__ + "static/media/Spinner.dff755aa.svg";